import React from 'react';

// Value to provide when Keycloak is not used and still allow components to reference this context.
const AuthenticationContext = React.createContext({
  authenticated: false,
  initialized: true,
});

export default AuthenticationContext;
